import Header from './components/Header';
import Hero from './components/Hero';
import SectionRanking from './components/SectionRanking';
import SectionTopics from './components/SectionTopics';
import SectionUpdates from './components/SectionUpdates';
import SectionIndex from './components/SectionIndex';
import SectionCards from './components/SectionCards';
import SectionAbout from './components/SectionAbout';
import SectionFAQ from './components/SectionFAQ';
import SectionMedia from './components/SectionMedia';
import SectionCarousel from './components/SectionCarousel';
import SectionContact from './components/SectionContact';
import SectionFeatures from './components/SectionFeatures';
import SectionComments from './components/SectionComments';
import SectionApp from './components/SectionApp';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionRanking />
        <SectionTopics />
        <SectionUpdates />
        <SectionIndex />
        <SectionCards />
        <SectionAbout />
        <SectionFAQ />
        <SectionMedia />
        <SectionCarousel />
        <SectionContact />
        <SectionFeatures />
        <SectionComments />
        <SectionApp />
      </main>
      <Footer />
    </>
  );
}